import { reactive } from 'vue'
import { authAPI } from '@/services/api'

export const userStore = reactive({
  user: {
    id: null,
    email: '',
    is_admin: false,
    is_superuser: false,
    is_pchelp: false,
    client_id: null
  },
  loading: false,
  error: null,

  async fetchUser() {
    this.loading = true
    this.error = null
    try {
      const response = await authAPI.me()
      this.user = response.data
    } catch (err) {
      console.error('Error fetching user data:', err)
      this.error = err
    } finally {
      this.loading = false
    }
  },

  clearUser() {
    this.user = {
      id: null,
      email: '',
      is_admin: false,
      is_superuser: false,
      is_pchelp: false,
      client_id: null
    }
  }
})
